"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderMenu = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var react_1 = __importStar(require("react"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_application_1 = require("@ryerson/frontend.application");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_2 = require("@emotion/react");

var SwapAccount_1 = __importDefault(require("./SwapAccount"));

exports.SliderMenu = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\ttransition: left 0.3s linear;\n\tposition: fixed;\n\twidth: 100%;\n\ttop: 50px;\n\theight: 100vh;\n\tmax-height: 100vh;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tz-index: ", ";\n\n\t&.slide-open {\n\t\tleft: 0%;\n\t}\n\n\t&.slide-close {\n\t\tleft: -100%;\n\t}\n\n\t", "\n"])), frontend_common_1.IndexedLayers.header, function (props) {
  var theme = props.theme;
  return (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tbackground-color: ", ";\n\t\t"])), theme.colors.primary.lighterGray);
});

var SwapAccountMobile = function SwapAccountMobile(_ref) {
  var openSwapAccount = _ref.openSwapAccount,
      handleClose = _ref.handleClose;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      isNative = _ref3.isNative;

  var _ref4 = (0, react_1.useState)({}),
      _ref5 = _slicedToArray(_ref4, 1),
      domNodeRefs = _ref5[0];

  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      hasMounted = _react_1$default$useS2[0],
      setHasMounted = _react_1$default$useS2[1];

  var windowSize = (0, frontend_common_1.useWindowSize)();

  var createDomNodeRef = function createDomNodeRef(fieldName) {
    domNodeRefs[fieldName] = (0, react_1.createRef)();
    return domNodeRefs[fieldName];
  }; // Manage slider animation and body scrolling


  (0, react_1.useEffect)(function () {
    var _a, _b;

    if (hasMounted) {
      var sliderEl = domNodeRefs["swap-account"].current;
      (_a = sliderEl === null || sliderEl === void 0 ? void 0 : sliderEl.classList) === null || _a === void 0 ? void 0 : _a.toggle("slide-open");
      (_b = sliderEl === null || sliderEl === void 0 ? void 0 : sliderEl.classList) === null || _b === void 0 ? void 0 : _b.toggle("slide-close");
    }
  }, [openSwapAccount]);
  (0, react_1.useEffect)(function () {
    setHasMounted(true);
  }, []);
  (0, frontend_common_1.useBodyScrollDisable)(openSwapAccount);
  return (0, jsx_runtime_1.jsx)(frontend_layout_1.ContentSection, {
    vPadding: "0",
    hPadding: "0",
    children: (0, jsx_runtime_1.jsx)(exports.SliderMenu, {
      theme: theme,
      ref: createDomNodeRef("swap-account"),
      className: "swap-account slide-close",
      css: {
        top: isNative ? "calc(env(safe-area-inset-top) + 60px)" : 100
      },
      children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        css: {
          height: windowSize[1] - 100,
          overflowY: "scroll"
        },
        direction: "column",
        children: (0, jsx_runtime_1.jsx)(SwapAccount_1.default, {
          handleClose: handleClose,
          isMobile: true,
          openSwapAccount: openSwapAccount
        })
      })
    })
  });
};

exports.default = SwapAccountMobile;